import { Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const ShareAnywhereImage = styled.div`
  border-bottom: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 40px 16px 16px 16px;
  text-align: center;

  ${Image.S.Image} {
    margin-bottom: 36px;
    object-fit: contain;
  }
`;

const ShareAnywhereLinks = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  padding: 16px 50px;
`;

const ShareAnywhereLink = styled.a`
  align-items: center;
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 64px;
  justify-content: center;
  padding: 8px;
  width: 72px;

  &:hover {
    background-color: var(--color-gray-50);
  }
`;

const ShareAnywhereText = styled(Typography)``;

const ShareAnywhere = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  overflow: hidden;
  width: 480px;

  ${DEVICE.tablet.max} {
    width: 100%;
  }
`;

export {
  ShareAnywhere,
  ShareAnywhereImage,
  ShareAnywhereLink,
  ShareAnywhereLinks,
  ShareAnywhereText
};
